import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface RecentActivityItem {
  event_type: "message_sent" | "reply_received" | "vonigo_status_change";
  occurred_at: string;
  quote_id: string | null;
  template_id: string | null;
  customer_name: string | null;
  ghosted?: boolean;
  title: string;
  detail: string;
}

export function useRecentActivity(limit = 10, enabled = true) {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["control-tower", "activity", "recent", limit],
    queryFn: async () => {
      const res = await fetch(`/api/cockpit/activity/recent?limit=${limit}`, { headers });
      if (!res.ok) throw new Error(`Recent activity failed: ${res.status}`);
      return res.json() as Promise<{ items: RecentActivityItem[] }>;
    },
    enabled,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
